// Kit Diario — JS propio, vanilla, sin librerias externas.
document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initEscenaDia();
  initGaleriaProducto();
  initSelectorVariantes();
  initFaq();
  initContadores();
});

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

// ---------- Reveals al hacer scroll ----------
function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (prefersReducedMotion() || typeof IntersectionObserver === 'undefined') {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  // Red de seguridad: si algo falla y un elemento nunca entra en pantalla
  // (o el observer no llega a dispararse), no debe quedar invisible para siempre.
  setTimeout(function () {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
  }, 4000);
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.dataset.mtDelay || 0;
        setTimeout(function () { entry.target.classList.add('mt-visible'); }, delay);
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el, i) {
    el.dataset.mtDelay = (i % 4) * 90;
    obs.observe(el);
  });
}

// ---------- Escena sticky de "Dia ordenado" ----------
function initEscenaDia() {
  var secciones = document.querySelectorAll('[data-mt-dia]');
  secciones.forEach(function (raiz) {
    var pasos = raiz.querySelectorAll('[data-mt-paso]');
    var imgs = raiz.querySelectorAll('[data-mt-visual]');
    if (!pasos.length || !imgs.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = entry.target.dataset.mtPaso;
          imgs.forEach(function (img) {
            img.classList.toggle('mt-visual-activa', img.dataset.mtVisual === idx);
          });
        }
      });
    }, { threshold: 0.55 });
    pasos.forEach(function (p) { obs.observe(p); });
  });
}

// ---------- Galeria de producto (miniaturas) ----------
function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.dataset.mtMiniatura;
        var img = principal.querySelector('img');
        if (img && src) img.src = src;
        minis.forEach(function (m) { m.classList.remove('mt-miniatura-activa'); });
        mini.classList.add('mt-miniatura-activa');
      });
    });
  });
}

// ---------- Selector de variantes simple ----------
function initSelectorVariantes() {
  var wraps = document.querySelectorAll('[data-mt-producto-form]');
  wraps.forEach(function (wrap) {
    var selectNativo = wrap.querySelector('[data-mt-select-variante]');
    var botones = wrap.querySelectorAll('[data-mt-opcion]');
    if (!selectNativo || !botones.length) return;
    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var grupo = btn.dataset.mtGrupo;
        wrap.querySelectorAll('[data-mt-grupo="' + grupo + '"]').forEach(function (b) {
          b.classList.remove('mt-opcion-activa');
        });
        btn.classList.add('mt-opcion-activa');

        var seleccion = {};
        wrap.querySelectorAll('.mt-producto__variante-grupo').forEach(function (g) {
          var activo = g.querySelector('.mt-opcion-activa');
          if (activo) seleccion[g.dataset.mtGrupo] = activo.dataset.mtValor;
        });

        var opciones = JSON.parse(selectNativo.dataset.mtVariantes || '[]');
        var match = opciones.find(function (v) {
          return v.opciones.every(function (o, i) { return seleccion[i] === o; });
        });
        if (match) {
          selectNativo.value = match.id;
          selectNativo.dispatchEvent(new Event('change', { bubbles: true }));
          var precioEl = wrap.querySelector('[data-mt-precio-actual]');
          if (precioEl) precioEl.textContent = match.precio;
          var addBtn = wrap.querySelector('[data-mt-add]');
          if (addBtn) {
            addBtn.disabled = !match.disponible;
            addBtn.textContent = match.disponible ? addBtn.dataset.mtTextoComprar : addBtn.dataset.mtTextoAgotado;
          }
        }
      });
    });
  });
}

// ---------- FAQ acordeon ----------
function initFaq() {
  var items = document.querySelectorAll('.mt-faq__item');
  items.forEach(function (item) {
    var boton = item.querySelector('.mt-faq__pregunta');
    var respuesta = item.querySelector('.mt-faq__respuesta');
    if (!boton || !respuesta) return;
    boton.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-faq-abierto');
      items.forEach(function (i) {
        i.classList.remove('mt-faq-abierto');
        i.querySelector('.mt-faq__respuesta').style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('mt-faq-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

// ---------- Contadores animados ----------
function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.dataset.mtContador);
      var decimales = (el.dataset.mtContador.split('.')[1] || '').length;
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = valor.toFixed(decimales);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toFixed(decimales);
      }
      if (prefersReducedMotion()) { el.textContent = fin.toFixed(decimales); }
      else requestAnimationFrame(paso);
      obs.unobserve(el);
    });
  }, { threshold: 0.6 });
  els.forEach(function (el) { obs.observe(el); });
}
